/** Slot widths follow the max-width values on the about-page gallery slides. */
export const ABOUT_GALLERY_IMAGE_SIZES =
  '(min-width: 1024px) 588px, (min-width: 768px) 450px, (min-width: 640px) 320px, (min-width: 276px) 260px, calc(100vw - 16px)';

/** Slot widths follow the max-width values on the service-gallery slides. */
export const SERVICE_GALLERY_IMAGE_SIZES =
  '(min-width: 1024px) 588px, (min-width: 768px) 490px, (min-width: 640px) 380px, (min-width: 276px) 260px, calc(100vw - 16px)';
